// extracted by mini-css-extract-plugin
export default {"root":"styles_root__yFa7T","dragging-over":"styles_dragging-over__hdsRG","draggingOver":"styles_dragging-over__hdsRG","color":"styles_color__xsVyD"};